/**
 * Computes current/longest streaks from a list of YYYY-MM-DD date strings.
 * `frozenDates` (dates a streak-freeze was applied to) are treated as active
 * days so a single missed day doesn't break the chain.
 */
export function computeStreaks(dateStrings, { frozenDates } = {}) {
  const frozen = frozenDates instanceof Set ? frozenDates : new Set(frozenDates || []);
  const merged = new Set(
    [...(dateStrings || []).filter(Boolean), ...frozen]
  );
  if (!merged.size) return { currentStreak: 0, longestStreak: 0 };

  const uniqueDates = [...merged].sort();

  // Longest streak: longest run of consecutive calendar days.
  let best = 1;
  let run = 1;
  for (let i = 1; i < uniqueDates.length; i++) {
    const diff = (new Date(uniqueDates[i]) - new Date(uniqueDates[i - 1])) / 86400000;
    if (diff === 1) {
      run++;
      if (run > best) best = run;
    } else {
      run = 1;
    }
  }

  // Current streak: walk backward from today or yesterday (a miss today
  // doesn't zero the streak until tomorrow).
  const todayStr = new Date().toISOString().slice(0, 10);
  const yestStr = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  const dateSet = new Set(uniqueDates);
  let current = 0;
  if (dateSet.has(todayStr) || dateSet.has(yestStr)) {
    let d = new Date(`${dateSet.has(todayStr) ? todayStr : yestStr}T12:00:00`);
    while (dateSet.has(d.toISOString().slice(0, 10))) {
      current++;
      d = new Date(d.getTime() - 86400000);
    }
  }

  return { currentStreak: current, longestStreak: uniqueDates.length === 1 ? 1 : best };
}
